package com.wintermar.inspection.feature.data.remote.mapper.answer

import com.wintermar.inspection.core.ui.component.image.util.FileUploadStatus
import com.wintermar.inspection.feature.domain.model.answer.AnswerFileModel
import migrations.AnswerFileTable

fun AnswerFileTable.toAnswerFileModel(
): AnswerFileModel {
    return AnswerFileModel(
        id = this.id,
        answerId = this.answerId,
        name = this.name,
        originalName = this.originalName ?: "",
        path = this.path ?: "",
        size = this.size ?: 0,
        type = this.type ?: "",
        blob = this.blob,
        hasGenerateChunk = this.hasGenerateChunk ?: false,
        uploadStatus = if (this.uploadStatus == null) FileUploadStatus.NONE else FileUploadStatus.valueOf(
            this.uploadStatus
        )
    )
}
